import {
  Box,
  Modal,
  Typography,
  LinearProgress,
  useTheme,
} from '@mui/material';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TypeAnimation } from 'react-type-animation';

const TYPING_DELAY = 1000;
const TYPING_SPEED = 50;
const TYPING_DELETION_SPEED = 80;

interface Props {
  open: boolean;
}

const Loader: FC<Props> = ({ open }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const getSequence = useCallback(() => {
    const typings = [
      t('aiRecommendations:loader:subtitle1'),
      t('aiRecommendations:loader:subtitle2'),
      t('aiRecommendations:loader:subtitle3'),
      t('aiRecommendations:loader:subtitle4'),
      t('aiRecommendations:loader:subtitle5'),
      t('aiRecommendations:loader:subtitle6'),
      t('aiRecommendations:loader:subtitle7'),
      t('aiRecommendations:loader:subtitle8'),
    ];

    return typings
      .sort(() => 0.5 - Math.random())
      .reduce<Array<string | number>>((acc, typing, index) => {
        if (index > 0) {
          acc.push(TYPING_DELAY);
        }
        acc.push(typing);
        return acc;
      }, []);
  }, [t]);

  return (
    <Modal
      open={open}
      sx={{
        width: '80%',
        maxWidth: 800,
        height: '50%',
        maxHeight: 350,
        backgroundColor: theme.palette.grey[50],
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        margin: 'auto',
      }}
    >
      <Box
        padding={1}
        sx={{
          backgroundColor: theme.palette.grey[50],
          width: '100%',
          height: '100%',
          color: theme.palette.grey[900],
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          outline: 'none',
        }}
      >
        <Typography
          data-testid="recommendation-loader-title"
          variant="h3"
          marginBottom={2}
          fontWeight={500}
        >
          {t('aiRecommendations:loader:title')}
        </Typography>
        <Typography
          component={TypeAnimation}
          sequence={getSequence()}
          speed={TYPING_SPEED}
          deletionSpeed={TYPING_DELETION_SPEED}
          cursor
          repeat={Infinity}
          data-testid="recommendation-loader-subtitle"
          marginBottom={2}
        />
        <LinearProgress
          color="secondary"
          sx={{
            marginTop: 4,
            width: '70%',
          }}
        />
      </Box>
    </Modal>
  );
};

export default Loader;
